import axios from 'axios'
import laroute from '~/laroute'

// state
export const state = {
  userPermissionsAndActionTasks: [],
  permissions: [],
  actionTasks: []
}

// getters
export const getters = {
  userPermissionsAndActionTasks: state => state.userPermissionsAndActionTasks,
  token: state => state.token,
  company: state => state.company,
  permissions: state => state.permissions,
  actionTasks: state => state.actionTasks
}

// mutations
export const mutations = {
  SET_USER_PERMISSIONS_AND_ACTION_TASKS (state, data) {
    state.userPermissionsAndActionTasks = data
  },

  SET_PERMISSIONS (state, data) {
    state.permissions = data
  },

  SET_ACTION_TASKS (state, data) {
    state.actionTasks = data
  }

}

// actions
export const actions = {
  async fetchUserPermissionsAndActionTasks ({ commit }, value) {
    console.log(value)
    if (typeof value === 'object' && value.hasOwnProperty('company')) {
      const response = (value.userId === undefined)
        ? await axios.get(laroute.route('user_permissions', { companyAbbr: value.company }))
        : await axios.get(laroute.route('user_permissions', { companyAbbr: value.company, userId: value.userId }))

      commit('SET_USER_PERMISSIONS_AND_ACTION_TASKS', response.data)
    }
  },

  async fetchPermissions ({ commit }) {
    const response = await axios.get(laroute.route('permissions'))
    commit('SET_PERMISSIONS', response.data)
  },

  async fetchActionTasks ({ commit }) {
    const response = await axios.get(laroute.route('action_tasks'))
    commit('SET_ACTION_TASKS', response.data)
  },

  async editUserActionOnPermission ({ commit }, value) {
    const response = await axios.patch(laroute.route('user_permissions_edit', { companyAbbr: value.companyAbbr, userId: value.userId }),
      { permission_id: value.permission_id, action_id: value.action_id })
    commit('SET_USER_PERMISSIONS_AND_ACTION_TASKS', response.data)
  },

  async moduleAction ({ commit }, value) {
    let permissions = value.userPermissionsAndActionTasks
    let permissionName
    for (let permission of permissions) {
      permissionName = permission.app_permission.visible_name
      if (Array.isArray(value.moduleName.match(permissionName)) === true) {
        return permission.app_action_task.name
      }
    }
    return false
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/permission.js